import { subtype, SUBTYPE_OPTS, setSymbols, createProtoLayer } from '@type.engineering/type-engineer'
import { AbstractBuildingBlock } from '../../types/lux'
import Dep from './Dep'
import View from './View'
import Stateful from './Stateful'
import { createElement } from './lib'
// import addInstance, { previousConstructor } from './reloader'

const buildingBlockLayer = Symbol('building block')


export default class BuildingBlock extends AbstractBuildingBlock {
  /** @nocollapse */
  static control(el, opts) {
    /** @suppress {checkTypes} */
    const res = control(this, el, opts)
    return /** @type {!BuildingBlock} */ (res)
  }
}
// BuildingBlock.control = BuildingBlock.control // add to templates
// export control as api

/** @constructor @extends {BuildingBlock} @suppress {checkTypes} */ function _BuildingBlock() {}
AbstractBuildingBlock.__implement(View,Stateful,Dep,
  _BuildingBlock.prototype = /** @type {!BuildingBlock} */ ({
    get model() {
      const{asIStateful:{state}}=this
      return state
    },
    setState(newState, { forcePaint } = {}) {
      const { superStateful: { setState }, asIBuildingBlock: { __$paint } } = this
      const setStateRes = setState(newState)
      // const { allSame } = setStateRes
      // if (allSame) return setStateRes

      if (forcePaint) {
        __$paint()
      }

      return setStateRes
    },
    initialiser({props,classes,state}={}) {
      const{superStateful,superView}=this
      superView.initialiser({props,classes})
      superStateful.initialiser({state})
      return this
    },
    // __$see(data) {
    //   const { superPainter, superStateful } = this
    //   superPainter(data)
    //   superStateful(data)
    // },
    // __$control(el, props) {
    //   throw new Error('buildingBlock.__$control is deprecated.')
    // },
    get element() {
      return this
    },
  }),
)

/** @type {guest.maurice.control} */
export function control(Constructor, el, {
  props, state, classes, symbols, setSymbols: setSymbolsLocal, shadow = false,
} = {}, allSymbols = null) {
  /** @type {!guest.maurice.BuildingBlock<!guest.maurice.State,!guest.maurice.Properties>} */
  let ell
  if (!shadow) {
    // can possibly hash layers
    const layer = createProtoLayer(el, buildingBlockLayer)

    /** @suppress {checkTypes} */
    const Fn = /** @type {function(new:Object)} */ ({ prototype: layer })
    subtype(Fn, SUBTYPE_OPTS, Constructor)
    Object.setPrototypeOf(el, layer)

    // forward type-of? from Constructor
    ell = /** @type {!guest.maurice.BuildingBlock<!guest.maurice.State,!guest.maurice.Properties>} */ (el)

    if (symbols&&setSymbolsLocal)setSymbolsLocal(ell,symbols)
  } else {
    ell=/** @type {!guest.maurice.BuildingBlock<!guest.maurice.State,!guest.maurice.Properties>} */(createElement(Constructor, el))
  }
  _mvc(ell, { props, state, classes, symbols }, allSymbols)
  return ell
}

/**
 * @param {!guest.maurice.BuildingBlock} ell
 * @param {guest.maurice.ComponentOptions} [opts]
 * @param {Object} [allSymbols]
 */
const _mvc = (ell, {
  props, state, classes, symbols,
} = {}, allSymbols) => {
  if(allSymbols&&symbols)setSymbols(ell,symbols,allSymbols)

  const {asIInitialiser:{initialiser},asIEngineer:{__$constructor}} = ell
  initialiser({props,classes,state})
  __$constructor() // start the component.

  return ell
}

/** @type {guest.maurice.mvc} */
export const mvc = (Constructor, el, opts, allSymbols) => {
  const ell=createElement(Constructor, el)
  _mvc(ell, opts, allSymbols)
  return ell
}